import axios from 'axios'
import { Id } from 'src/types'

const toodoKey = '123e4567-e89b-12d3-a456-426614174000'
const toodoUrl = 'https://microservices.toodo.com.br'

const options = { headers: { xapikey: `${toodoKey}` } }

export interface UpdateRequestTicketReceiptPayload {
  organization_id: Id
  user_id: Id
  receipt: {
    reference_id: number
    currency_id: number
    payment_resource_id: number
    service_id: number
    justification: string
  }
  image?: {
    request_ticket_receipt_image_id: number | null
    image_base64: string
    active: boolean
  }[]
}

export function updateRequestTicketReceipt(
  request_ticket_id: Id,
  request_ticket_receipt_id: Id,
  payload: UpdateRequestTicketReceiptPayload
): Promise<any> {
  const url = `${toodoUrl}/request-tickets/${request_ticket_id}/receipts/${request_ticket_receipt_id}`
  return axios.post(url, payload, options)
}
